import React, { useState } from 'react';
import styled from '@emotion/styled';
import AccordionTitle from './AccordionTitle';
import Collapse from './Collapse';
import { Box, Paper } from './styles';

const AccordionWrapper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: 0,
  borderRadius: '0.75rem',
  [theme.breakpoints.down('md')]: {
    marginBottom: '0.75rem',
  },
}));

type AccordionType = {
  title: string;
  children: React.ReactNode;
  subtitle?: string;
  noPadding?: boolean;
  imagePath?: string;
  controlledVisibility?: {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
  };
};

export default function Accordion({
  title,
  children,
  subtitle,
  noPadding,
  controlledVisibility,
  imagePath,
}: AccordionType) {
  const [internalShow, setInternalShow] = useState(false);

  const isControlled = controlledVisibility !== undefined;
  const show = isControlled ? controlledVisibility.isOpen : internalShow;
  const setShow = isControlled ? controlledVisibility.setIsOpen : setInternalShow;

  const handleClickTitle = (e: React.MouseEvent) => {
    e.preventDefault();
    setShow(!show);
  };

  return (
    <AccordionWrapper>
      <AccordionTitle imagePath={imagePath}
        text={title}
        onClick={handleClickTitle}
        show={show}
        subtitle={subtitle}
      />
      <Collapse open={show}>
        <Box style={{ paddingTop: noPadding ? 0 : 3 }}  p={{ xs: 1, md: 2, lg: 3 }}>
          {children}
        </Box>
      </Collapse>
    </AccordionWrapper>
  );
}
